import { Alert } from 'reactstrap'

const ProductionTimeBanner = ({ cartItems }) => {
  // Check if any cart item has fulfillment_production_time
  const hasProductionTime = cartItems && cartItems.some(item => item.fulfillment_production_time)

  if (!hasProductionTime) {
    return null
  }

  return (
    <Alert color="warning" className="mb-3">
      <strong>Production Time:</strong> Some products may require additional production time before fulfillment.
      Please review individual product details below.
    </Alert>
  )
}

export default ProductionTimeBanner
